import { useState, useEffect, useRef } from "react";
import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';

// import useAxios from "../../components/useAxios";
import authAxios from "../../components/authAxios";

import { Autocomplete } from "@mui/material";
import { TextField } from "@mui/material";

import { Modal, message } from 'antd';

import NumberFormat from "react-number-format";
import UserAlerts from "../../components/UserAlerts";
import useDebounce from "../../components/useDebounce";

function PaymentEdit({payment:failedPayment, isModalOpen, setIsModalOpen}) {
    const autocompleteRef = useRef(null);

    // const {response, error, fetchData}  = useAxios();
    const [error, setError] = useState('');
    const errorRef = useRef(null);
    const queryClient = useQueryClient();

    const [searchText, setSearchText] = useState('');
    const debouncedSearchText = useDebounce(searchText, 500);
    const [selectedLease, setSelectedLease] = useState(null);
    const [selectedLoan, setSelectedLoan] = useState(null);
    const [amt, setAmt] = useState('');
    const [customer, setCustomer] = useState(null);


    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };


    // const { data: leases, isLoading, isFetching } = useQuery({
    //     queryKey: ['leases', debouncedSearchText],
    //     queryFn: async () => {  
    //         const response = await authAxios.get("/rentals/leases", {params: {search: debouncedSearchText}});
    //         return response.data
    //     },
    //     enabled: !!debouncedSearchText.trim(),
    //     keepPreviousData: true,
    //     initialData: []
    // });

    const { data: loans, isLoading, isFetching } = useQuery({
        queryKey: ['loans', debouncedSearchText],
        queryFn: async () => {  
            const response = await authAxios.get("/loans/loans", {params: {search: debouncedSearchText}});
            return response.data
        },
        enabled: !!debouncedSearchText.trim(),
        keepPreviousData: true,
        initialData: []
    });


    // Fetch full loan details when a loan is selected
    // This is to get the disbursement amount, avoid expensive query on full loans list

    const { data: loan } = useQuery({
        queryKey: ['loan', selectedLoan],
        queryFn: async () => {  
            const response = await authAxios.get(`/loans/loans/${selectedLoan.id}/`);
            if (response.data.net_disbursement_amount != null) {
                // setAmt(String(response.data.net_disbursement_amount));
                setAmt(String(response.data.amount));
            }
            return response.data
        },
        // enabled: !!selectedLoan && (txnType === "810"), // Only fetch when a loan is selected and transaction type is disbursement
        enabled: !!selectedLoan // Only fetch when a loan is selected and transaction type is disbursement

    });

    const [customerReference, setCustomerReference] = useState('');

    const mutation = useMutation({
        mutationFn: (paymentData) => {
            // return authAxios.post("payments/payments/allocate/", paymentData);
            return authAxios.post(`payments/payments/${failedPayment.id}/reconcile/`, paymentData);
        },
        onError: (error, variables, context) => {
            if (error.response.data.error){
                if (Array.isArray(error.response.data.error)) {
                    error.response.data.error.map((errorMessage) => (
                        setError(errorMessage)
                    ));
                } else {
                    setError(error.response.data.error); 
                }
            } else {
                setError(error.message); 
            }      
        },
        onSuccess: (result) => {
            queryClient.invalidateQueries(['payments', 'payment']);
            queryClient.refetchQueries(['payments']);
            queryClient.refetchQueries(['payment']);
            setIsModalOpen(false)
            message.success('Payment allocated successfully');
        },
        
        onSettled: () => {
            // setError('') //TODO: REVISIT THIS FEATURE
            setSelectedLease(null)
            setSearchText('')
            setCustomerReference('')
        }
    })


    const handleSubmit = (e) => {
        e.preventDefault();

        // if (failedPayment && selectedLease) {
        //     const loan = selectedLoan.id
        //     const payment = failedPayment.id
        //     const amount = failedPayment.amount
        //     const date = failedPayment.date
        //     const paymentData = {customer, loan, payment, amount, date };
        //     console.log(paymentData)
        //     mutation.mutate(paymentData)
        // } 
        if (!customer) {
            setError("Please select a customer")
            return;
        }
        const loan_case = selectedLoan.loan_case
        const payment = failedPayment.id
        const amount = failedPayment.amount
        const date = failedPayment.date
        const paymentData = {customer, loan_case, payment, amount, date };
        console.log(paymentData)
        mutation.mutate(paymentData)
    }

    useEffect(()=>{
        if (error){
            errorRef.current.scrollIntoView();  
        }            
    },[error])

    useEffect(() => {
        if (isModalOpen && autocompleteRef.current) {
          autocompleteRef.current.focus();
        }
      }, [isModalOpen]);


    return(
        <>
        {isModalOpen && failedPayment && 
            <Modal 
                className="dashboard-modal" 
                title="Post Payment" 
                visible={isModalOpen} 
                open={isModalOpen} 
                onOk={handleSubmit} 
                onCancel={handleCancel}
                confirmLoading={mutation.isLoading}
            >
                <div className="dashboard-form">

                    <div ref={errorRef}>
                        <UserAlerts error={error}  />
                    </div>

                    <form noValidate autoComplete="off" onSubmit={handleSubmit}>

                        <TextField className="custom-input"
                            defaultValue = {failedPayment.reference}
                            InputProps={{ readOnly: true }}
                            label="Reference" 
                            variant="outlined" 
                            fullWidth
                        />

                        <TextField className="custom-input"
                            fullWidth
                            label="Paid By" 
                            variant="outlined" 
                            defaultValue = {failedPayment.customer_name}
                            InputProps={{ readOnly: true }}
                        />
                           <NumberFormat 
                            className="custom-input"
                            fullWidth
                            label="Amount" 
                            variant="outlined" 
                            customInput={TextField}
                            thousandSeparator={true} 
                            defaultValue = {failedPayment.amount}
                            InputProps={{ readOnly: true }}
                        />  

                        {/* <Autocomplete
                            value={selectedLease}   
                            onClose={(e, reason) => {
                                if (reason === 'blur' && (!selectedLease || (selectedLease && searchText !== selectedLease.customer_name))) {
                                    setSearchText('');
                                    setSelectedLease(null);
                                    }
                                }}
                            
                            onChange={(event, newValue) => {
                                setSelectedLease(newValue);
                                setSearchText(newValue.customer_name)
                                setCustomerReference(newValue.customer_code);
                            }}
                            inputValue={searchText}
                            onInputChange={(event, newInput, reason) => {
                                if (reason === 'input') {
                                    setSearchText(newInput);
                                }
                                }}
                            options={leases || []} 
                            getOptionLabel={(option) => { 
                                return option ? option.name : '' }
                            } // Ensure option is not null or undefined


                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            noOptionsText={
                                searchText.trim().length < 1
                                    ? 'Please enter name or phone number'
                                    : isFetching
                                    ? 'Loading…'
                                    : 'No matches found. Please try another search term.'
                            }
                            loading={isFetching}
                            renderInput={(params) => <TextField className="custom-input" fullWidth {...params} label="Customer"  /> }
                        /> */}

                        <Autocomplete
                            value={selectedLoan}   
                            
                            onClose={(e, reason) => {
                                // when the menu closes, sync inputText back to
                                // the selected value’s label (or empty if none)
                                if (reason === 'blur' && (!selectedLoan || (selectedLoan && searchText !== selectedLoan.customer_name))) {
                                    setSearchText('');
                                    setSelectedLoan(null);
                                    setCustomer(null);
                                    // setCustomerError(true)
                                    }
                                }}
                            
                            onChange={(event, newValue) => {
                                console.log("SELECTED LOAN", newValue)
                                setSelectedLoan(newValue);
                                setCustomer(newValue.customer);
                                // setCustomerError(false)
                                setSearchText(newValue.customer_name)
                            }}
                            inputValue={searchText}
                            onInputChange={(event, newInput, reason) => {
                                if (reason === 'input') {
                                    setSearchText(newInput);
                                }
                                }}
                            options={loans || []} 

                            getOptionLabel={(option) => { 
                                return option ? option.customer_name + ' (' + option.lc_reference + ')' : '' }} // Ensure option is not null or undefined
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            noOptionsText={
                                searchText.trim().length < 1
                                    ? 'Please enter name or phone number'
                                    : isFetching
                                    ? 'Loading…'
                                    : 'No matches found. Please try another search term.'
                            }
                            loading={isFetching}
                            renderInput={(params) => <TextField className="custom-input" fullWidth {...params} label="Customer"  /> }
                        />

                    </form>
                </div>
            </Modal>
        }
        </>

    )

}

export default PaymentEdit;
